<htx-button variant="tertiary" icon="arrow_back" (click)="goBack()">
  {{ 'button.back' | transloco }}
</htx-button>

<article class="privacy-policy-container" *transloco="let t; prefix: 'privacyPolicy'">
  <h1 class="pp-title">{{ t('title') }}</h1>

  <p class="pp-intro">
    Diese Datenschutzhinweise beschreiben, wie der Datenraumträger [HealthTrack-X]
    personenbezogene Daten im Zusammenhang mit der Nutzung des Portals „HealthTrack-X"
    (nachfolgend <strong>„HT-X Portal"</strong>) verarbeitet.
  </p>
  <p class="pp-intro">
    Das HT-X Portal dient der Registrierung und Verwaltung von Organisationen als Teilnehmer des
    Datenraums „HealthTrack-X" sowie der Bereitstellung ausgewählter Portal-Funktionen für
    registrierte Teilnehmer, insbesondere der Verwaltung von Nutzerkonten und der Darstellung
    teilnehmender Organisationen im Partnernetzwerk.
  </p>

  <section class="pp-section">
    <h2 class="pp-h2">1. Anwendungsbereich</h2>
    <p>
      Diese Datenschutzhinweise gelten ausschließlich für die Verarbeitung personenbezogener Daten
      im Zusammenhang mit der Bereitstellung, Nutzung und Verwaltung des HT-X Portals durch den
      Datenraumträger HT-X.
    </p>
    <p>
      Sie gelten nicht für Datenverarbeitungen, die im Rahmen eines fachlichen Datenaustauschs
      zwischen einzelnen teilnehmenden Organisationen oder sonstigen Beteiligten erfolgen,
      insbesondere im Zusammenhang mit Use Cases wie Lieferkettenmanagement, Datenlieferungen zur
      Vermeidung von Versorgungsengpässen oder CO₂-Tracking. Für solche Datenverarbeitungen sind
      die jeweils am Datenaustausch teilnehmenden Organisationen selbst verantwortlich. Diese haben
      eigenständig sicherzustellen, dass die jeweils anwendbaren datenschutzrechtlichen
      Anforderungen eingehalten und, soweit erforderlich, gesonderte Datenschutzhinweise
      bereitgestellt werden. Weitere Informationen hierzu finden Sie in Abschnitt 5 dieser
      Datenschutzhinweise.
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">2. Verantwortlicher</h2>
    <p>
      Verantwortlicher im Sinne der Datenschutz-Grundverordnung, Art. 4 Nr. 7 DSGVO, ist
      [HealthTrack-X], [Anschrift], [E-Mail], [Telefon] (nachfolgend <strong>„HT-X"</strong>).
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">3. Datenschutzbeauftragter</h2>
    <p>
      Den Datenschutzbeauftragten von HT-X erreichen Sie unter [Name/Organisation des
      Datenschutzbeauftragten], [E-Mail], [Anschrift, optional].
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">4. Verarbeitung personenbezogener Daten im Rahmen des HT-X Portals</h2>
    <p>
      Im Zusammenhang mit der Nutzung des HT-X Portals verarbeitet HT-X personenbezogene Daten nur
      in dem Umfang, der für die technische Bereitstellung des HT-X Portals, die Registrierung und
      Verwaltung teilnehmender Organisationen, die Verwaltung von Nutzerkonten sowie die
      Bereitstellung der vorgesehenen Portal-Funktionen erforderlich ist.
    </p>

    <h3 class="pp-h3">4.1 Bereitstellung des HT-X Portals und Server-Logfiles</h3>
    <p>
      Wenn Sie das HT-X Portal aufrufen, erfasst das System von HT-X aus technischen Gründen
      automatisch bestimmte Informationen. Hierzu können insbesondere gehören:
    </p>
    <ul class="pp-list">
      <li>IP-Adresse des aufrufenden Endgeräts;</li>
      <li>Datum und Uhrzeit des Zugriffs;</li>
      <li>aufgerufene Seiten bzw. Inhalte;</li>
      <li>übertragene Datenmenge;</li>
      <li>Meldung über erfolgreichen Abruf;</li>
      <li>verwendeter Browser und Browserversion;</li>
      <li>verwendetes Betriebssystem;</li>
      <li>Referrer-URL, soweit übermittelt.</li>
    </ul>
    <p>
      Diese Daten werden verarbeitet, um das HT-X Portal technisch bereitzustellen, die
      Funktionsfähigkeit und Stabilität des HT-X Portals sicherzustellen, Fehler zu analysieren,
      Missbrauch und Sicherheitsvorfälle zu erkennen sowie die Sicherheit der
      informationstechnischen Systeme von HT-X zu gewährleisten.
    </p>
    <p>
      Rechtsgrundlage für diese Verarbeitung ist Art. 6 Abs. 1 lit. f DSGVO. Das berechtigte
      Interesse von HT-X besteht darin, das HT-X Portal sicher, stabil und funktionsfähig
      bereitzustellen sowie Angriffe, Störungen und missbräuchliche Nutzungen erkennen und
      verhindern zu können.
    </p>
    <p>
      Die Server-Logfiles werden gelöscht oder anonymisiert, sobald sie für die genannten Zwecke
      nicht mehr erforderlich sind, spätestens jedoch nach sieben Tagen, sofern keine längere
      Speicherung im Einzelfall zur Aufklärung oder Abwehr von Sicherheitsvorfällen oder aufgrund
      regulatorischer Vorgaben, insbesondere zu Auditierungs- und Nachweiszwecken, erforderlich
      ist. In diesen Fällen werden die betreffenden Protokolldaten nur im erforderlichen Umfang und
      für die jeweils erforderliche Dauer gespeichert.
    </p>

    <h3 class="pp-h3">4.2 Registrierung und Freigabe teilnehmender Organisationen</h3>
    <p>
      Für die Teilnahme am Datenraum „HealthTrack-X" müssen sich die teilnehmenden Organisationen
      vorab im HT-X Portal als Teilnehmer registrieren (nachfolgend <strong>„Teilnehmer"</strong>).
      Im Rahmen der Registrierung verarbeitet HT-X organisationsbezogene Angaben sowie
      personenbezogene Daten von Ansprechpartnern oder vertretungsberechtigten Personen des
      jeweiligen Teilnehmers. Hierzu können insbesondere folgende Daten gehören:
    </p>
    <ul class="pp-list">
      <li>Name der teilnehmenden Organisation;</li>
      <li>Anschrift und sonstige Organisationsangaben des Teilnehmers;</li>
      <li>Vorname und Nachname vertretungsberechtigter Personen;</li>
      <li>geschäftliche E-Mail-Adresse;</li>
      <li>geschäftliche Telefonnummer, soweit angegeben;</li>
      <li>Position/Funktion in der Organisation;</li>
      <li>sonstige Angaben, die im Rahmen der Registrierung übermittelt werden.</li>
    </ul>
    <p>
      HT-X verarbeitet diese Daten, um die Registrierung der Organisation als Teilnehmer zu prüfen,
      über die Freigabe oder Ablehnung der Teilnahme zu entscheiden, die Organisation als
      registrierter Teilnehmer im Portal anzulegen und das Nutzungsverhältnis vorzubereiten bzw.
      durchzuführen.
    </p>
    <p>
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung zur Durchführung
      vorvertraglicher Maßnahmen oder zur Begründung und Durchführung des Nutzungsverhältnisses
      erforderlich ist. Soweit HT-X die Angaben zur Prüfung der Teilnahmeberechtigung, zur
      Missbrauchsvermeidung oder zur ordnungsgemäßen Verwaltung des HT-X Portals verarbeitet, ist
      Rechtsgrundlage Art. 6 Abs. 1 lit. f DSGVO. Das berechtigte Interesse von HT-X besteht in der
      geordneten, sicheren und kontrollierten Verwaltung des HT-X Portals und seiner registrierten
      Teilnehmer.
    </p>
    <p>
      Wird eine Registrierung abgelehnt, löscht HT-X die im Rahmen der Registrierung verarbeiteten
      personenbezogenen Daten, sobald sie für die Entscheidung über die Registrierung und etwaige
      Rückfragen nicht mehr erforderlich sind, sofern keine gesetzlichen Aufbewahrungspflichten
      oder berechtigten Interessen an einer weiteren Speicherung bestehen.
    </p>

    <h3 class="pp-h3">4.3 Anlage und Verwaltung des Teilnehmerkontos</h3>
    <p>
      Nach erfolgreicher Freigabe der Registrierung legt HT-X die registrierte Organisation als
      Teilnehmer im HT-X Portal an. Dabei verarbeitet HT-X die für die Verwaltung des
      Teilnehmerkontos erforderlichen Angaben. Hierzu können insbesondere gehören:
    </p>
    <ul class="pp-list">
      <li>Name und Stammdaten des Teilnehmers;</li>
      <li>Organisations- und Rolleninformationen;</li>
      <li>Name und Kontaktdaten des administrativen Ansprechpartners;</li>
      <li>Status der Teilnahme bzw. Registrierung;</li>
      <li>technische Account- und Verwaltungsdaten;</li>
      <li>Berechtigungs- und Rolleninformationen.</li>
    </ul>
    <p>
      Die Verarbeitung erfolgt, um das Teilnehmerkonto bereitzustellen, die registrierte
      Organisation als Teilnehmer im HT-X Portal zu verwalten, Zugriffsrechte zuzuweisen und die
      Nutzung der Portal-Funktionen zu ermöglichen.
    </p>
    <p>
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung für die Durchführung
      des Nutzungsverhältnisses erforderlich ist. Ergänzend ist Art. 6 Abs. 1 lit. f DSGVO
      Rechtsgrundlage, soweit die Verarbeitung der sicheren, nachvollziehbaren und ordnungsgemäßen
      Verwaltung des HT-X Portals dient.
    </p>

    <h3 class="pp-h3">4.4 Verwaltung von Nutzerkonten und Einladung weiterer Teammitglieder</h3>
    <p>
      Teilnehmer können im HT-X Portal weitere Nutzer bzw. Teammitglieder ihrem Teilnehmerkonto
      hinzufügen oder zur Nutzung des HT-X Portals einladen. Die Verwaltung dieser Nutzer erfolgt
      durch den jeweiligen Teilnehmer bzw. dessen Administratoren. In diesem Zusammenhang können
      insbesondere folgende personenbezogene Daten verarbeitet werden:
    </p>
    <ul class="pp-list">
      <li>Vorname und Nachname;</li>
      <li>geschäftliche E-Mail-Adresse;</li>
      <li>geschäftliche Telefonnummer, soweit angegeben;</li>
      <li>Position/Funktion in der Organisation, soweit angegeben;</li>
      <li>Organisationszugehörigkeit;</li>
      <li>Rolle und Berechtigungen im HT-X Portal;</li>
      <li>Status des Nutzerkontos;</li>
      <li>technische Account- und Nutzungsdaten.</li>
    </ul>
    <p>
      Soweit personenbezogene Daten von Nutzern oder Ansprechpartnern nicht unmittelbar bei diesen
      selbst erhoben werden, sondern durch den jeweiligen Teilnehmer oder dessen Administratoren im
      HT-X Portal hinterlegt werden, stammen diese Daten von dem jeweiligen Teilnehmer. Die
      betreffenden Datenkategorien ergeben sich aus den in diesen Datenschutzhinweisen
      beschriebenen Angaben.
    </p>
    <p>
      Diese Daten werden verarbeitet, um Nutzerkonten anzulegen, Einladungen zu versenden, Nutzer
      des jeweiligen Teilnehmers zuzuordnen, Zugriffsrechte zu verwalten und die Nutzung des HT-X
      Portals durch den jeweiligen Teilnehmer zu ermöglichen.
    </p>
    <p>
      Die Administratoren des jeweiligen Teilnehmers können die dem Teilnehmerkonto zugeordneten
      Nutzer und die dort hinterlegten Angaben einsehen und verwalten.
    </p>
    <p>
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung zur Durchführung des
      Nutzungsverhältnisses mit dem jeweiligen Teilnehmer erforderlich ist. Soweit die Verarbeitung
      der sicheren und effizienten Nutzerverwaltung innerhalb des HT-X Portals dient, ist
      Rechtsgrundlage Art. 6 Abs. 1 lit. f DSGVO. Das berechtigte Interesse von HT-X besteht in der
      Bereitstellung einer geordneten Rollen- und Rechteverwaltung für den jeweiligen Teilnehmer.
    </p>

    <h3 class="pp-h3">4.5 Darstellung im Partnernetzwerk</h3>
    <p>
      Der Teilnehmer kann im HT-X Portal in einer Partnernetzwerkübersicht dargestellt werden. Die
      Partnernetzwerkübersicht dient dazu, die teilnehmenden Organisationen gegenüber anderen
      Teilnehmern sichtbar zu machen und die Kontaktaufnahme sowie Vernetzung innerhalb des
      HealthTrack-X Ökosystems zu ermöglichen. In der Partnernetzwerkübersicht können insbesondere
      folgende Angaben angezeigt werden:
    </p>
    <ul class="pp-list">
      <li>Name der teilnehmenden Organisation;</li>
      <li>Vorname und Nachname des Ansprechpartners;</li>
      <li>geschäftliche E-Mail-Adresse des Ansprechpartners;</li>
      <li>ggf. weitere geschäftliche Kontaktdaten, soweit vorgesehen oder angegeben.</li>
    </ul>
    <p>
      Die Verarbeitung erfolgt, um dem Teilnehmer eine Übersicht über andere Teilnehmer
      bereitzustellen und die Vernetzung innerhalb des HT-X Portals zu ermöglichen.
    </p>
    <p>
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Darstellung Bestandteil der
      Portalnutzung und des Nutzungsverhältnisses ist. Ergänzend ist Art. 6 Abs. 1 lit. f DSGVO
      Rechtsgrundlage. Das berechtigte Interesse von HT-X besteht darin, den Austausch und die
      Vernetzung der Teilnehmer im Rahmen des HT-X Portals zu ermöglichen.
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">5. Keine Geltung für den fachlichen Datenaustausch zwischen Teilnehmern</h2>
    <p>
      Das HT-X Portal kann einen organisatorischen oder technischen Rahmen für die Teilnahme an
      bestimmten Use Cases oder Datenaustauschszenarien bieten. Diese Datenschutzhinweise erfassen
      jedoch nicht die Verarbeitung personenbezogener Daten, die im Rahmen eines konkreten
      Datenaustauschs zwischen einzelnen Teilnehmern oder sonstigen Beteiligten erfolgt.
    </p>
    <p>
      Soweit teilnehmende Organisationen im Rahmen von Use Cases, Projekten, Lieferkettenprozessen,
      CO₂-Tracking, Versorgungsengpassmanagement oder sonstigen Datenaustauschszenarien
      personenbezogene Daten verarbeiten oder austauschen, sind die jeweiligen teilnehmenden
      Organisationen für diese Verarbeitung selbst verantwortlich, sofern und soweit nicht
      ausdrücklich etwas anderes vereinbart ist. Die teilnehmenden Organisationen haben
      insbesondere selbst zu prüfen, ob und in welchem Umfang personenbezogene Daten verarbeitet
      werden, welche Rechtsgrundlagen einschlägig sind, welche Informationspflichten bestehen und
      welche technischen und organisatorischen Maßnahmen erforderlich sind.
    </p>
    <p>
      Wenn Sie weitere Informationen zur Verarbeitung personenbezogener Daten im Rahmen eines
      konkreten Datenaustauschs wünschen, wenden Sie sich bitte an die teilnehmende Organisation,
      die an dem betreffenden Datenaustausch beteiligt ist. Diese teilnehmende Organisation ist für
      die Bereitstellung der insoweit erforderlichen Datenschutzinformationen verantwortlich.
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">6. Cookies und ähnliche Technologien</h2>
    <p>
      Im HT-X Portal werden derzeit keine nicht technisch erforderlichen Cookies oder
      vergleichbaren Technologien eingesetzt.
    </p>
    <p>
      Soweit technisch erforderliche Cookies oder vergleichbare Technologien eingesetzt werden,
      dienen diese ausschließlich dazu, das HT-X Portal bereitzustellen, Sitzungen zu verwalten,
      Sicherheitsfunktionen zu ermöglichen oder vom Nutzer ausdrücklich angeforderte Funktionen
      bereitzustellen. Eine Nutzung zu Analyse-, Tracking- oder Werbezwecken findet derzeit nicht
      statt.
    </p>
    <p>
      Rechtsgrundlage für die Verarbeitung personenbezogener Daten im Zusammenhang mit technisch
      erforderlichen Cookies oder vergleichbaren Technologien ist Art. 6 Abs. 1 lit. f DSGVO. Das
      berechtigte Interesse von HT-X besteht in der sicheren, stabilen und funktionsfähigen
      Bereitstellung des HT-X Portals. Soweit der Einsatz technisch erforderlicher Cookies oder
      vergleichbarer Technologien unbedingt erforderlich ist, um einen vom Nutzer ausdrücklich
      gewünschten Telemediendienst bereitzustellen, erfolgt dieser zudem nach Maßgabe von § 25
      Abs. 2 Nr. 2 TDDDG.
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">7. Empfänger personenbezogener Daten und Auftragsverarbeiter</h2>

    <h3 class="pp-h3">7.1 Empfänger personenbezogener Daten</h3>
    <p>
      Innerhalb der Organisation von HT-X erhalten nur diejenigen Stellen Zugriff auf
      personenbezogene Daten, die diesen Zugriff zur Erfüllung der oben genannten Zwecke benötigen.
    </p>
    <p>
      Eine Weitergabe personenbezogener Daten an Dritte erfolgt nur, soweit dies zur Bereitstellung
      und Verwaltung des HT-X Portals erforderlich ist, eine gesetzliche Verpflichtung besteht,
      HT-X hierzu berechtigt ist oder eine Einwilligung vorliegt. Als Empfänger kommen insbesondere
      in Betracht:
    </p>
    <ul class="pp-list">
      <li>
        interne Stellen, die mit der Administration und Verwaltung des HT-X Portals befasst sind;
      </li>
      <li>
        Berater, Rechtsanwälte oder sonstige professionelle Dienstleister, soweit dies erforderlich
        ist;
      </li>
      <li>
        Behörden, Gerichte oder sonstige öffentliche Stellen, soweit HT-X gesetzlich hierzu
        verpflichtet ist oder dies zur Geltendmachung, Ausübung oder Verteidigung von
        Rechtsansprüchen erforderlich ist;
      </li>
      <li>
        Administratoren der jeweiligen Teilnehmer im Hinblick auf die dem Teilnehmerkonto
        zugeordneten Nutzer;
      </li>
      <li>
        andere registrierte Teilnehmer, soweit personenbezogene Daten in der
        Partnernetzwerkübersicht angezeigt werden.
      </li>
    </ul>

    <h3 class="pp-h3">7.2 Auftragsverarbeiter</h3>
    <p>
      HT-X kann externe Dienstleister einsetzen, die personenbezogene Daten im Auftrag von HT-X
      verarbeiten. Diese Dienstleister werden als Auftragsverarbeiter im Sinne von Art. 4 Nr. 8
      DSGVO tätig und verarbeiten personenbezogene Daten ausschließlich nach Weisungen von HT-X.
    </p>
    <p>
      Zu den von HT-X eingesetzten oder künftig einsetzbaren Kategorien von Auftragsverarbeitern
      können insbesondere gehören:
    </p>
    <ul class="pp-list">
      <li>Hosting- und Rechenzentrumsdienstleister;</li>
      <li>IT-Betriebs-, Wartungs- und Supportdienstleister;</li>
      <li>Anbieter von Plattform-, Portal- oder Cloud-Infrastruktur;</li>
      <li>Dienstleister für Nutzerverwaltung, Authentifizierung und Berechtigungsmanagement;</li>
      <li>
        Kommunikations- und E-Mail-Dienstleister, soweit diese für transaktionale Nachrichten oder
        portalbezogene Benachrichtigungen eingesetzt werden;
      </li>
      <li>Dienstleister für Datensicherung, Monitoring, Fehleranalyse und IT-Sicherheit.</li>
    </ul>
    <p>
      Mit den eingesetzten Auftragsverarbeitern schließt HT-X Verträge gemäß Art. 28 DSGVO ab.
      Diese verpflichten die Auftragsverarbeiter insbesondere dazu, personenbezogene Daten nur nach
      den Weisungen von HT-X zu verarbeiten, geeignete technische und organisatorische Maßnahmen
      zum Schutz personenbezogener Daten zu treffen und die Vertraulichkeit der verarbeiteten Daten
      sicherzustellen.
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">8. Datenübermittlungen in Drittländer</h2>
    <p>
      HT-X verarbeitet personenbezogene Daten grundsätzlich innerhalb der Europäischen Union (EU)
      bzw. des Europäischen Wirtschaftsraums (EWR).
    </p>
    <p>
      Eine Übermittlung personenbezogener Daten an Empfänger in Staaten außerhalb der EU bzw. des
      EWR, sogenannte Drittländer, findet derzeit nicht statt.
    </p>
    <p>
      Sollte künftig eine Übermittlung personenbezogener Daten in Drittländer erforderlich werden,
      erfolgt diese nur, soweit die Voraussetzungen der Art. 44 ff. DSGVO erfüllt sind, insbesondere
      auf Grundlage eines Angemessenheitsbeschlusses der Europäischen Kommission, geeigneter
      Garantien wie EU-Standardvertragsklauseln oder einer sonstigen gesetzlichen Erlaubnis.
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">9. Speicherdauer</h2>
    <p>
      HT-X speichert personenbezogene Daten nur so lange, wie dies für die Zwecke erforderlich ist,
      für die sie erhoben wurden, oder soweit gesetzliche Aufbewahrungspflichten bestehen.
    </p>
    <p>Für die einzelnen Verarbeitungsvorgänge gilt insbesondere:</p>
    <ul class="pp-list">
      <li>
        Server-Logfiles werden gelöscht oder anonymisiert, sobald sie für die Sicherstellung des
        technischen Betriebs und der Sicherheit nicht mehr erforderlich sind, spätestens nach sieben
        Tagen, sofern keine längere Speicherung im Einzelfall zur Aufklärung oder Abwehr von
        Sicherheitsvorfällen oder aufgrund regulatorischer Vorgaben, insbesondere zu Auditierungs-
        und Nachweiszwecken, erforderlich ist. In diesen Fällen werden die betreffenden
        Protokolldaten nur im erforderlichen Umfang und für die jeweils erforderliche Dauer
        gespeichert.
      </li>
      <li>
        Registrierungsdaten werden für die Dauer des Registrierungs- und Prüfprozesses gespeichert.
        Nach Ablehnung einer Registrierung werden die Daten gelöscht, sobald sie für die
        Entscheidung und etwaige Rückfragen nicht mehr erforderlich sind, sofern keine gesetzlichen
        Aufbewahrungspflichten oder berechtigten Interessen entgegenstehen.
      </li>
      <li>
        Daten von Teilnehmern und deren Ansprechpartnern werden für die Dauer der Teilnahme bzw.
        Portalnutzung gespeichert.
      </li>
      <li>
        Daten von Nutzerkonten und Teammitgliedern werden für die Dauer der Zuordnung zum
        jeweiligen Teilnehmerkonto gespeichert und gelöscht, wenn das Nutzerkonto gelöscht wird
        oder die Speicherung für die Portalverwaltung nicht mehr erforderlich ist.
      </li>
      <li>
        Daten in der Partnernetzwerkübersicht werden für die Dauer der Teilnahme bzw. solange
        angezeigt, wie die Darstellung für die Portalnutzung vorgesehen und erforderlich ist.
      </li>
    </ul>
    <p>
      Nach Wegfall des jeweiligen Zwecks werden die personenbezogenen Daten gelöscht, anonymisiert
      oder gesperrt, sofern gesetzliche Aufbewahrungspflichten einer Löschung nicht entgegenstehen.
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">10. Pflicht zur Bereitstellung personenbezogener Daten</h2>
    <p>
      Die Bereitstellung bestimmter personenbezogener Daten ist für die Registrierung, Freigabe und
      Nutzung des HT-X Portals erforderlich. Ohne die Bereitstellung der erforderlichen Angaben
      kann HT-X eine Registrierung nicht prüfen, ein Teilnehmerkonto nicht anlegen oder bestimmte
      Portal-Funktionen nicht bereitstellen.
    </p>
    <p>
      Die Angabe optionaler Daten, etwa zusätzlicher geschäftlicher Kontaktdaten, ist freiwillig.
      Werden optionale Daten nicht bereitgestellt, kann dies dazu führen, dass einzelne Komfort-
      oder Vernetzungsfunktionen nur eingeschränkt genutzt werden können.
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">11. Datenschutzrechte betroffener Personen</h2>
    <p>
      Nach Maßgabe der gesetzlichen Voraussetzungen stehen betroffenen Personen insbesondere die
      folgenden Rechte zu:
    </p>

    <h3 class="pp-h3">11.1 Recht auf Auskunft, Art. 15 DSGVO</h3>
    <p>
      Sie haben das Recht, Auskunft darüber zu verlangen, ob und welche personenbezogenen Daten HT-X
      über Sie verarbeitet.
    </p>

    <h3 class="pp-h3">11.2 Recht auf Berichtigung, Art. 16 DSGVO</h3>
    <p>
      Sie haben das Recht, die Berichtigung unrichtiger oder die Vervollständigung unvollständiger
      personenbezogener Daten zu verlangen.
    </p>

    <h3 class="pp-h3">11.3 Recht auf Löschung, Art. 17 DSGVO</h3>
    <p>
      Sie haben unter den gesetzlichen Voraussetzungen das Recht, die Löschung Ihrer
      personenbezogenen Daten zu verlangen.
    </p>

    <h3 class="pp-h3">11.4 Recht auf Einschränkung der Verarbeitung, Art. 18 DSGVO</h3>
    <p>
      Sie haben unter den gesetzlichen Voraussetzungen das Recht, die Einschränkung der
      Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
    </p>

    <h3 class="pp-h3">11.5 Recht auf Datenübertragbarkeit, Art. 20 DSGVO</h3>
    <p>
      Sie haben unter den gesetzlichen Voraussetzungen das Recht, personenbezogene Daten, die Sie
      HT-X bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu
      erhalten oder diese Daten einem anderen Verantwortlichen übermitteln zu lassen.
    </p>

    <h3 class="pp-h3">11.6 Recht auf Widerspruch, Art. 21 DSGVO</h3>
    <p>
      Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit
      Widerspruch gegen die Verarbeitung personenbezogener Daten einzulegen, die auf Grundlage von
      Art. 6 Abs. 1 lit. e oder lit. f DSGVO erfolgt. HT-X verarbeitet Ihre personenbezogenen Daten
      in diesem Fall nicht weiter, es sei denn, HT-X kann zwingende schutzwürdige Gründe für die
      Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die
      Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.
    </p>
    <p>
      Sofern HT-X personenbezogene Daten für Zwecke der Direktwerbung verarbeitet, haben Sie das
      Recht, jederzeit Widerspruch gegen diese Verarbeitung einzulegen. In diesem Fall wird HT-X
      Ihre personenbezogenen Daten nicht mehr für Zwecke der Direktwerbung verarbeiten.
    </p>

    <h3 class="pp-h3">11.7 Recht auf Widerruf einer Einwilligung, Art. 7 Abs. 3 DSGVO</h3>
    <p>
      Sofern eine Verarbeitung auf Ihrer Einwilligung beruht, können Sie diese Einwilligung
      jederzeit mit Wirkung für die Zukunft widerrufen. Die Rechtmäßigkeit der Verarbeitung, die
      aufgrund der Einwilligung bis zum Widerruf erfolgt ist, bleibt hiervon unberührt.
    </p>
    <p>
      Zur Ausübung Ihrer Rechte können Sie sich jederzeit unter den in diesen Datenschutzhinweisen
      angegebenen Kontaktmöglichkeiten an HT-X wenden.
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">12. Beschwerderecht bei einer Aufsichtsbehörde</h2>
    <p>
      Sie haben außerdem das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren, wenn
      Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen
      Datenschutzrecht verstößt.
    </p>
    <p>
      Die für HT-X zuständige Datenschutzaufsichtsbehörde ist: [Zuständige Aufsichtsbehörde],
      [Anschrift], [E-Mail / Website].
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">13. Kontakt</h2>
    <p>
      Bei Fragen zur Verarbeitung personenbezogener Daten im Zusammenhang mit dem HT-X Portal oder
      zur Ausübung Ihrer Datenschutzrechte können Sie sich jederzeit an HT-X wenden: [Kontakt
      Datenschutz / E-Mail]
    </p>
  </section>

  <section class="pp-section">
    <h2 class="pp-h2">14. Änderung dieser Datenschutzhinweise</h2>
    <p>
      HT-X behält sich das Recht vor, diese Datenschutzhinweise unter Beachtung der gesetzlichen
      Vorgaben zu ändern. Dies kann insbesondere erforderlich sein, wenn sich die Funktionen des
      HT-X Portals, die eingesetzten technischen Systeme oder die rechtlichen Anforderungen ändern.
    </p>
    <p>
      Es gilt jeweils die zum Zeitpunkt der Nutzung abrufbare Fassung dieser Datenschutzhinweise.
    </p>
    <p class="pp-stand"><strong>Stand: 23.06.2026</strong></p>
  </section>
</article>
